<template>
  <div id="Portfolio">
    <Hero class="lift">
      <Row>
        <Column :lg="6">
          <h1>
            {{ $t('title') }}
          </h1>
        </Column>
        <Column :lg="6">
          <div class="hero-side-text">
            <p>{{ $t('side') }}</p>
          </div>
        </Column>
      </Row>
    </Hero>
    <section id="Portfolio-entries">
      <Wrap>
        <Row>
          <Column
            v-for="portfolio in portfolios"
            :key="portfolio.id"
            :lg="4"
            :sm="6">
            <CardPortfolioSmall
              isShortSubtitle
              :portfolio="portfolio" />
          </Column>
        </Row>
      </Wrap>
    </section>
  </div>
</template>

<script>
import { actions, getters, uniqueArray } from 'views/utils'
import CardPortfolioSmall from '../Index/components/CardPortfolioSmall'
import Hero from 'views/components/Hero'
import Meta from 'views/mixins/Meta'

export default {
  mixins: [
    Meta(require('@/assets/social/projects.jpg')),
  ],
  components: {
    CardPortfolioSmall,
    Hero,
  },
  data() {
    return {
      selectedCountry: 'Poland',
      selectedType: 'all',
      projectTypes: [
        'all',
        'industrial',
        'commercial',
        'public',
      ],
      countriesWithFilters: [
        'Lithuania',
      ],
      limit: 6,
    }
  },
  computed: {
    doesCountryHaveFilters() {
      return this.countriesWithFilters.includes(this.selectedCountry)
    },
    countryByLocale() {
      if (this.locale === 'lt') { return 'Lithuania' }
      if (this.locale === 'pl') { return 'Poland' }

      return 'Poland'
    },
    existingProjectTypes() {
      return [
        // 'all',
        ...this.projectTypes
          .filter(projectType => this.portfolios
            .some(portfolio => portfolio.type === projectType)),
      ]
    },
    existingCountries() {
      return uniqueArray(this.portfolios.map(portfolio => portfolio.country))
    },
    portfolios() {
      return this.query('portfolio')
    },
    portfoliosQuery() {
      return {
        country: this.selectedCountry,
        ...(this.selectedType !== 'all'
          ? { type: this.selectedType }
          : {}),
      }
    },
    portfoliosOfType() {
      return this.query('portfolio', {
        ...this.portfoliosQuery,
        $limit: this.limit,
        $sort: { priority: 1 },
      })
    },
    portfoliosOfTypeCount() {
      return this.query('portfolio', this.portfoliosQuery).length
    },
    ...getters(),
  },
  methods: {
    setActiveCountry(country) {
      this.selectedCountry = (country || this.countryByLocale)
      this.selectedType = 'all'
    },
    setActiveType(type) {
      this.selectedType = this.selectedType === type ? 'all' : type
    },
    ...actions('FETCH_PORTFOLIO', 'FETCH_COUNTRY'),
  },
  beforeMount() {
    this.LOAD(this.FETCH_PORTFOLIO())
    this.LOAD(this.FETCH_COUNTRY())
  },
  mounted() {
    this.setActiveCountry()
  },
}
</script>

<style lang="scss">
#Portfolio {
  ~ #TopBar {
    .cta {
      background-color: $white;

      a {
        color: $main;
      }
    }

    &.sticky {
      .cta {
        background-color: $main;

        a {
          color: $white;
        }
      }
    }
  }

  .Hero {
    background-color: $main;
    background-image: url('../../../assets/ellipses.png');
    background-position: top right;
    background-repeat: no-repeat;
    background-size: 60%;
  }

  .Hero-body {
    @include lg {
      padding-top: 2rem;
    }

    .hero-side-text {
      @include lg {
        padding-left: 20%;
      }
    }
  }

  #Portfolio-entries {
    min-height: 6rem;
    padding-bottom: 5rem;
    position: relative;

    .filters {
      margin-top: 2rem;

      .Btn {
        background-color: $grey-light;
        border: none;
        color: $black;
        margin-left: 1rem;
        margin-top: auto;
        padding: 0 0.5rem;
        @include sm {
          padding: 0.5rem 1.5rem;
        }

        &.country {
          text-transform: uppercase;
        }

        &:hover {
          background-color: $grey-lightest;
        }

        &.active {
          background-color: $grey-lightest;
        }
      }

      .Row {
        margin: 0 0 2rem;
        text-align: center;
        @include md {
          justify-content: flex-end;
          margin: 0 0 1rem;
        }
      }
    }

    h2 {
      margin: 4rem 0 3rem;
    }

    .Empty {
      margin-top: 4rem;
      @include md {
        margin: 0;
      }
    }
  }

  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }
}
</style>

<i18n>
{
  "lt": {
    "meta": {
      "description": "Didžiuojamės įrengę jau daugiau nei 2000+ saulės elektrinių ant gyvenamųjų namų stogų.",
      "title": {
        "complement": "Nogrid",
        "inner": "Įgyvendinti projektai",
        "separator": "-"
      }
    },
    "side": "Didžiuojamės įrengę jau daugiau nei 2000+ saulės elektrinių ant gyvenamųjų namų stogų.",
    "title": "Įgyvendinti projektai",
    "projectTypes": {
      "all": "Visi",
      "industrial": "Industriniai",
      "commercial": "Komerciniai",
      "public": "Viešieji"
    },
    "countries": {
      "Lithuania": "Lietuva",
      "Poland": "Lenkija"
    },
    "more": "Load more"
  }
}
</i18n>
